export default __webpack_public_path__ + "static/media/S_Aplus_True.1dee6824.jpg";